import React from 'react';
import Teaser from "../components/Teaser";

class Verify extends React.Component {

    params = this.props.match.params;
    state = {
        teaser: Teaser.chooseTeaser(),
        confirmation: null
    };

    componentDidMount() {

        const confirmation_ok = (
            <>
                <h1>Ihre E-Mail Adresse wurde verifiziert.</h1>
                <p className={"notice"}>
                    Der Datenredaktion liegt nun Ihr Eintrag zur Prüfung vor. Sie werden von uns oder der 11880.com in kürze kontaktiert zur Überprüfung der Angaben
                </p>
            </>
        );

        const confirmation_fail = (
            <>
                <h1 style={{color: 'red'}}>Fehler.</h1>
                <p className={"notice"} style={{color: 'red'}}>
                    Token oder Eintrag unbekannt.
                </p>
            </>
        );

        fetch('https://yellow-api-ng.opendi.com/api/de/listing-form/' + this.params.listingId + '/confirm?token=' + this.params.token, {
            'method': 'post'
        }).then((response) => {
            if (response.status === 204) {
                this.setState({
                    confirmation: confirmation_ok
                });

                this.props.ga.event({
                    category: 'Form',
                    action: 'E-Mail address verified',
                });
            } else {
                this.setState({
                    confirmation: confirmation_fail
                });
            }
        }).catch(() => {
            this.setState({
                confirmation: confirmation_fail
            });
        });
    }

    render() {
        return (

            <div className={"wrap"}>

                <header>
                    <a href="https://www.stadtbranchenbuch.com/" target="_blank" rel="noopener noreferrer">
                        <img src={require('../images/stadtbranchenbuch_logo.png')} alt="opendi.com logo"
                             className="logo"/>
                    </a>
                </header>

                <main style={{backgroundImage: `url(${this.state.teaser.image})`}}>

                    <Teaser teaser={this.state.teaser}/>

                    <div className={"frame row"}>

                        <div className={"col-md-5 col-11 "}>
                            <div className={"sidebar"}>
                                <h1><i className={"lni-map-marker"}/> Ihr kostenloser Firmeneintrag </h1>
                                <ul>
                                    <li><i className={"lni-check-mark-circle"}/> auf 2 Portalen: stadtbranchenbuch.com und 11880.com</li>
                                    <li><i className={"lni-check-mark-circle"}/> schnell &uuml;ber 3 Mio. Besucher
                                        monatlich erreichen
                                    </li>
                                    <li><i className={"lni-check-mark-circle"}/> einfach gefunden werden</li>
                                    <li><i className={"lni-check-mark-circle"}/> seri&ouml;s Ihren Kundenstamm erweitern
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className={"form confirmation col-md-6 col-11"}>

                            {this.state.confirmation}

                            <p className={"notice"}>
                                Bei Fragen stehen wir Ihnen gerne zur Verfügung: <a href={"mailto:info@opendi.com"}>info@opendi.com</a>
                            </p>

                            <hr />

                            <p className={"notice"}>
                                Unterstützen Sie unsere Seite und werden Sie Fan bei Facebook!
                            </p>
                            <a href="https://www.facebook.com/Stadtbranchenbuch" rel={"noopener noreferrer"} target={"_blank"} >
                                <img src="//static.opendi.com/_img/facebook.png" alt="" style={{'paddingTop': '10px'}} />
                            </a>
                        </div>
                    </div>

                </main>

                <footer>
                    <a href="https://www.stadtbranchenbuch.com/content/impressum.html">Impressum </a> | <a
                    href="https://www.stadtbranchenbuch.com/content/datenschutz.html">Datenschutz</a>
                </footer>

            </div>

        );
    }
}

export default Verify;
